// This file is auto-generated by update-translation-configuration script.
// Don't edit it manually, instead run `npm run update-translation-configuration`.

export enum Language {
    'da-DK' = 'da-DK',
    'de-DE' = 'de-DE',
    'en-GB' = 'en-GB',
    'es-ES' = 'es-ES',
    'fi-FI' = 'fi-FI',
    'fr-FR' = 'fr-FR',
    'is-IS' = 'is-IS',
    'nl-NL' = 'nl-NL',
    'no-NO' = 'no-NO',
    'pt-PT' = 'pt-PT',
    'ru-RU' = 'ru-RU',
    'sv-SE' = 'sv-SE',
    'zh-CN' = 'zh-CN',
}

export const languages = [
    Language['da-DK'],
    Language['de-DE'],
    Language['en-GB'],
    Language['es-ES'],
    Language['fi-FI'],
    Language['fr-FR'],
    Language['is-IS'],
    Language['nl-NL'],
    Language['no-NO'],
    Language['pt-PT'],
    Language['ru-RU'],
    Language['sv-SE'],
    Language['zh-CN'],
];
export const defaultLanguage = Language['en-GB'];

export { default as defaultDictionary } from '@/translations/modules/en-GB';

import adminBillingTranslations from '@/admin/billing/i18n/translations.en-GB.json';
import adminBrandingTranslations from '@/admin/branding/i18n/translations.en-GB.json';
import adminCategoriesTranslations from '@/admin/categories/i18n/translations.en-GB.json';
import adminCoursesTranslations from '@/admin/courses/i18n/translations.en-GB.json';
import adminEventsTranslations from '@/admin/events/i18n/translations.en-GB.json';
import adminGroupsTranslations from '@/admin/groups/i18n/translations.en-GB.json';
import adminTranslations from '@/admin/i18n/translations.en-GB.json';
import adminIntegrationsTranslations from '@/admin/integrations/i18n/translations.en-GB.json';
import adminIntegrationsOpenSesameTranslations from '@/admin/integrations/open-sesame/i18n/translations.en-GB.json';
import adminLoggingTranslations from '@/admin/logging/i18n/translations.en-GB.json';
import adminPlaylistsTranslations from '@/admin/playlists/i18n/translations.en-GB.json';
import adminRolesTranslations from '@/admin/roles/i18n/translations.en-GB.json';
import adminSettingsTranslations from '@/admin/settings/i18n/translations.en-GB.json';
import adminSkillsTranslations from '@/admin/skills/i18n/translations.en-GB.json';
import adminTopicsTranslations from '@/admin/topics/i18n/translations.en-GB.json';
import adminUsersTranslations from '@/admin/users/i18n/translations.en-GB.json';
import authenticationTranslations from '@/authentication/i18n/translations.en-GB.json';
import commonComponentsTranslations from '@/common/components/i18n/translations.en-GB.json';
import commonTranslations from '@/common/i18n/translations.en-GB.json';
import contentStoreTranslations from '@/content-store/i18n/translations.en-GB.json';
import conversationsActionItemsTranslations from '@/conversations/action-items/i18n/translations.en-GB.json';
import conversationsDocumentsNotesTranslations from '@/conversations/documents/notes/i18n/translations.en-GB.json';
import conversationsDocumentsTalkingPointsTranslations from '@/conversations/documents/talking-points/i18n/translations.en-GB.json';
import conversationsTranslations from '@/conversations/i18n/translations.en-GB.json';
import coursesTranslations from '@/courses/i18n/translations.en-GB.json';
import eventsTranslations from '@/events/i18n/translations.en-GB.json';
import impersonationTranslations from '@/impersonation/i18n/translations.en-GB.json';
import instructorsEventsOverviewTranslations from '@/instructors/i18n/events-overview/translations.en-GB.json';
import managersTranslations from '@/managers/i18n/translations.en-GB.json';
import managersManagerGroupConversationsTranslations from '@/managers/manager-group-conversations/i18n/translations.en-GB.json';
import notificationsTranslations from '@/notifications/i18n/translations.en-GB.json';
import openInAppTranslations from '@/open-in-app/i18n/translations.en-GB.json';
import personalSpaceTranslations from '@/personal-space/i18n/translations.en-GB.json';
import profileSettingsTranslations from '@/profile-settings/i18n/translations.en-GB.json';
import reportingCommonTranslations from '@/reporting/common/i18n/translations.en-GB.json';
import reportingCoursesCoursesTranslations from '@/reporting/courses/courses/i18n/translations.en-GB.json';
import reportingEventsEventsTranslations from '@/reporting/events/events/i18n/translations.en-GB.json';
import reportingGroupsTranslations from '@/reporting/groups/i18n/translations.en-GB.json';
import reportingPlaylistsTranslations from '@/reporting/playlists/i18n/translations.en-GB.json';
import reportingSegmentsTranslations from '@/reporting/segments/i18n/translations.en-GB.json';
import reportingSkillsTranslations from '@/reporting/skills/i18n/translations.en-GB.json';
import reportingUsersTranslations from '@/reporting/users/i18n/translations.en-GB.json';

export type AdminBillingTranslationsKeys = keyof typeof adminBillingTranslations;
export type AdminBrandingTranslationsKeys = keyof typeof adminBrandingTranslations;
export type AdminCategoriesTranslationsKeys = keyof typeof adminCategoriesTranslations;
export type AdminCoursesTranslationsKeys = keyof typeof adminCoursesTranslations;
export type AdminEventsTranslationsKeys = keyof typeof adminEventsTranslations;
export type AdminGroupsTranslationsKeys = keyof typeof adminGroupsTranslations;
export type AdminTranslationsKeys = keyof typeof adminTranslations;
export type AdminIntegrationsTranslationsKeys = keyof typeof adminIntegrationsTranslations;
export type AdminIntegrationsOpenSesameTranslationsKeys = keyof typeof adminIntegrationsOpenSesameTranslations;
export type AdminLoggingTranslationsKeys = keyof typeof adminLoggingTranslations;
export type AdminPlaylistsTranslationsKeys = keyof typeof adminPlaylistsTranslations;
export type AdminRolesTranslationsKeys = keyof typeof adminRolesTranslations;
export type AdminSettingsTranslationsKeys = keyof typeof adminSettingsTranslations;
export type AdminSkillsTranslationsKeys = keyof typeof adminSkillsTranslations;
export type AdminTopicsTranslationsKeys = keyof typeof adminTopicsTranslations;
export type AdminUsersTranslationsKeys = keyof typeof adminUsersTranslations;
export type AuthenticationTranslationsKeys = keyof typeof authenticationTranslations;
export type CommonComponentsTranslationsKeys = keyof typeof commonComponentsTranslations;
export type CommonTranslationsKeys = keyof typeof commonTranslations;
export type ContentStoreTranslationsKeys = keyof typeof contentStoreTranslations;
export type ConversationsActionItemsTranslationsKeys = keyof typeof conversationsActionItemsTranslations;
export type ConversationsDocumentsNotesTranslationsKeys = keyof typeof conversationsDocumentsNotesTranslations;
export type ConversationsDocumentsTalkingPointsTranslationsKeys =
    keyof typeof conversationsDocumentsTalkingPointsTranslations;
export type ConversationsTranslationsKeys = keyof typeof conversationsTranslations;
export type CoursesTranslationsKeys = keyof typeof coursesTranslations;
export type EventsTranslationsKeys = keyof typeof eventsTranslations;
export type ImpersonationTranslationsKeys = keyof typeof impersonationTranslations;
export type InstructorsEventsOverviewTranslationsKeys = keyof typeof instructorsEventsOverviewTranslations;
export type ManagersTranslationsKeys = keyof typeof managersTranslations;
export type ManagersManagerGroupConversationsTranslationsKeys =
    keyof typeof managersManagerGroupConversationsTranslations;
export type NotificationsTranslationsKeys = keyof typeof notificationsTranslations;
export type OpenInAppTranslationsKeys = keyof typeof openInAppTranslations;
export type PersonalSpaceTranslationsKeys = keyof typeof personalSpaceTranslations;
export type ProfileSettingsTranslationsKeys = keyof typeof profileSettingsTranslations;
export type ReportingCommonTranslationsKeys = keyof typeof reportingCommonTranslations;
export type ReportingCoursesCoursesTranslationsKeys = keyof typeof reportingCoursesCoursesTranslations;
export type ReportingEventsEventsTranslationsKeys = keyof typeof reportingEventsEventsTranslations;
export type ReportingGroupsTranslationsKeys = keyof typeof reportingGroupsTranslations;
export type ReportingPlaylistsTranslationsKeys = keyof typeof reportingPlaylistsTranslations;
export type ReportingSegmentsTranslationsKeys = keyof typeof reportingSegmentsTranslations;
export type ReportingSkillsTranslationsKeys = keyof typeof reportingSkillsTranslations;
export type ReportingUsersTranslationsKeys = keyof typeof reportingUsersTranslations;

export type TranslationKey =
    | AdminBillingTranslationsKeys
    | AdminBrandingTranslationsKeys
    | AdminCategoriesTranslationsKeys
    | AdminCoursesTranslationsKeys
    | AdminEventsTranslationsKeys
    | AdminGroupsTranslationsKeys
    | AdminTranslationsKeys
    | AdminIntegrationsTranslationsKeys
    | AdminIntegrationsOpenSesameTranslationsKeys
    | AdminLoggingTranslationsKeys
    | AdminPlaylistsTranslationsKeys
    | AdminRolesTranslationsKeys
    | AdminSettingsTranslationsKeys
    | AdminSkillsTranslationsKeys
    | AdminTopicsTranslationsKeys
    | AdminUsersTranslationsKeys
    | AuthenticationTranslationsKeys
    | CommonComponentsTranslationsKeys
    | CommonTranslationsKeys
    | ContentStoreTranslationsKeys
    | ConversationsActionItemsTranslationsKeys
    | ConversationsDocumentsNotesTranslationsKeys
    | ConversationsDocumentsTalkingPointsTranslationsKeys
    | ConversationsTranslationsKeys
    | CoursesTranslationsKeys
    | EventsTranslationsKeys
    | ImpersonationTranslationsKeys
    | InstructorsEventsOverviewTranslationsKeys
    | ManagersTranslationsKeys
    | ManagersManagerGroupConversationsTranslationsKeys
    | NotificationsTranslationsKeys
    | OpenInAppTranslationsKeys
    | PersonalSpaceTranslationsKeys
    | ProfileSettingsTranslationsKeys
    | ReportingCommonTranslationsKeys
    | ReportingCoursesCoursesTranslationsKeys
    | ReportingEventsEventsTranslationsKeys
    | ReportingGroupsTranslationsKeys
    | ReportingPlaylistsTranslationsKeys
    | ReportingSegmentsTranslationsKeys
    | ReportingSkillsTranslationsKeys
    | ReportingUsersTranslationsKeys;
